export { Panel, type PanelProps } from './Panel';
